export const FLL = {
	defaultValues: {
		height: 131,
		width: 1000,
		windowQuantity: 1,
		ug: {
			glass0: 0
		},
		psi:  {
			glass0: 0
		},
		isolation: false,
		glassThickness: null,
		glassTypes: 0
	},
	fixedValues: {
		middleMullion: true,
		isolation: true,
	},
	edgeTop: {
		W_m2K: 2.825,
	},
	edgeSide: {
		W_m2K: 2.825,

	},
	edgeBottom: {
		W_m2K: 2.825,
	},
	louvre: {
		W_m2K: 2.825,
		W_m2K_iso: 1.386
	},
	middleMullion: {
		W_m2K: 2.825,
		width: 70,
		min: 440,
		max: 2600
	},
	windowWidth: {
		min: 200,
		max: 1300,
		nrwgMax: 1300
	},
	windowHeight: {
		min: 317,
		max: 1270
	},
	louvreHeight: {
		min: 131,
		max: 131
	},
	edgeWidth: 40,
	gabDimensions: {
		side: 5,
		top: 4.5,
		middle: 5,
		bottom: 4.5
	},
	allowance: {
		width: 0,
		height: 0
	},
	area: {},

	cvReference85deg: 0.61,
	cvFactors: {cv1: 0.02, cv2: 0.02, cv3: 0.04},
	dimensionsOpenLouvre: {
		sideMullion: 45,
		profileTop: 27,
		profileBottom: 30,
		louvre: 27,
	},
	windLoadCalculation: {
		wl3000: {
			wMax: 1210,
			hMax: 131,
			aMax: 0.16
		},
	},

};

